"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppSocketProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const useRequest_1 = __importDefault(require("../hooks/useRequest"));
const useSocket_1 = require("../hooks/useSocket");
const useGptImage_1 = require("../hooks/useGptImage");
const user_1 = require("../slices/user");
const document_1 = require("../slices/document");
const subscription_1 = require("../slices/subscription");
const character_1 = require("../services/character");
const conversation_1 = require("../services/conversation");
const document_2 = require("../helper/document");
const appSocketContext = (0, react_1.createContext)({});
function AppSocketProvider({ children }) {
    const { request } = (0, useRequest_1.default)();
    const { generateImages } = (0, useGptImage_1.useGptImage)();
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const character = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const lastMessage = (0, react_redux_1.useSelector)((state) => state.getUserOptions.lastMessage);
    const oldLastMessageIdRef = (0, react_1.useRef)();
    const { socketRef, isSocketConnected } = (0, useSocket_1.useSocket)(appUser, fbUser);
    const dispatch = (0, react_redux_1.useDispatch)();
    /**
     *
     */
    (0, react_1.useEffect)(() => {
        console.log("Socket event update...:", isSocketConnected);
        if (socketRef.current &&
            isSocketConnected &&
            appUser?.id) {
            const socket = socketRef.current;
            console.log("SOCKET message listener update again.....");
            const socketListener = (message) => {
                console.log("SOCKET EVENT:", message?.type);
                switch (message?.type) {
                    // Quota updated from server:
                    // -- After message sent from user
                    // ---?
                    case "QUOTA_UPDATE":
                        const responseQuota = message.payload.quota;
                        dispatch((0, subscription_1.setUserQuota)({ ...responseQuota, uid: appUser?.id }));
                        break;
                    // Message sent: completed from server
                    case "LAST_MESSAGE":
                        const lastMessage = message?.payload?.lastMessage;
                        dispatch((0, user_1.patchConversation)({
                            id: lastMessage.conversationId.toString(),
                            changes: {
                                lastMessageId: lastMessage.id.toString(),
                            },
                        }));
                        dispatch((0, document_1.patchDocumentConversation)({
                            id: message.payload.characterId,
                            changes: {
                                lastMessageId: lastMessage.id.toString(),
                            },
                        }));
                        dispatch((0, user_1.setLastMessage)(lastMessage));
                        break;
                    // Message sent: completed from server
                    case "CONVERSATION":
                        const lastConversation = message?.payload?.conversation;
                        console.log("SOCKET CONVERSATION:", lastConversation);
                        dispatch((0, user_1.setLastConversation)(lastConversation));
                        // dispatch(setConversationLastMessageId(lastConversation.lastMessageId));
                        // @todo: update conversations in redux.
                        // Specific conversation is updated from server.
                        // {total:10, updatedConversation:{id:10, lastMessage:{}}}
                        // Check for updatedConversation & update in redux.
                        //  If total is not matching, refresh from API
                        break;
                    case "CONVERSATION_STARTED":
                        // Started new conversation
                        break;
                    case "NEW_CHARACTER_RESPONSE":
                        const newCharacter = message.payload.data;
                        dispatch((0, user_1.setDocumentCharacter)(newCharacter));
                        dispatch((0, document_1.addDocument)({
                            character: newCharacter,
                            conversation: newCharacter.conversation,
                            files: newCharacter.files,
                            tinySummary: '',
                        }));
                        break;
                    case "GENERATED_MIDJOUREY_IMAGES":
                        dispatch((0, document_1.patchLatestDocumentCharacter)({
                            temporaryImage: message.payload.imageUrl[0],
                        }));
                        break;
                    case "JSON_UPLOADED":
                        dispatch((0, document_1.setDocumentUploadComplete)(true));
                        fetch(message.payload.jsonPath)
                            .then((response) => response.json())
                            .then((json) => {
                            dispatch((0, document_1.upsertDocumentJson)({
                                ...json,
                                jsonPath: message.payload.jsonPath,
                            }));
                            dispatch((0, document_1.patchDocument)({
                                id: json.character_id,
                                changes: {
                                    tinySummary: (0, document_2.getMarkdownContent)(json.summaryResponse, 'Tiny Summary'),
                                    ...(json.podcastAudioUrl && { isPodcastGenerating: 'N' })
                                }
                            }));
                            dispatch((0, document_1.patchDocumentCharacter)({
                                id: json.character_id,
                                changes: {
                                    characterName: json.title,
                                    jsonPath: message.payload.jsonPath,
                                },
                            }));
                            dispatch((0, document_1.patchDocumentSummary)({
                                id: json.character_id,
                                changes: {
                                    ...json,
                                    fileIds: (json.files?.map((file) => file.id) || json.fileId && [json.fileId] || ['']),
                                    fileUrls: (json.files?.map((file) => file.urlPath)
                                        || json.fileUrl && [json.fileUrl]
                                        || ['']),
                                },
                            }));
                        });
                        break;
                    // case "UPLOADED_AUDIO_URL":
                    //   dispatch(patchDocumentJson({
                    //     fiveMinWrapAudioUrl: message.payload.audioUrl,
                    //   }));
                    //   break;
                    // case "UPLOADED_PODCAST_AUDIO_URL":
                    //   dispatch(patchDocumentJson({
                    //     podcastAudioUrl: message.payload.podcastUrl,
                    //   }));
                    //   break;
                }
            };
            socket.on(`${appUser.id}`, socketListener);
            return () => {
                console.log("Turn off Socket....!", appUser?.id);
                socket.off(appUser.id, socketListener);
                // closeSocket();
            };
        }
    }, [isSocketConnected, appUser]);
    (0, react_1.useEffect)(() => {
        if (lastMessage && !lastMessage.isMedia && lastMessage.id !== oldLastMessageIdRef.current) {
            oldLastMessageIdRef.current = lastMessage.id;
            if (lastMessage.conversationId === conversation?.id) {
                dispatch((0, user_1.insertNewMessage)(lastMessage));
                if (character.enableAutoGenImages === 'Y') {
                    generateImages(lastMessage?.mediaText ?? lastMessage.message ?? '', lastMessage.mediaId ?? lastMessage.id.toString(), character, Boolean(lastMessage.parentMessageId ?? lastMessage.mediaId));
                }
                ;
            }
            else {
                request(conversation_1.getConversation, lastMessage?.conversationId ?? '')
                    .then((conversationResponse) => {
                    if (conversationResponse) {
                        return request(character_1.getCharacterProfile, conversationResponse.data?.participant?.id.toString() ?? '');
                    }
                    ;
                }).then((characterResponse) => {
                    if (characterResponse?.data.enableAutoGenImages === 'Y') {
                        generateImages(lastMessage?.mediaText ?? lastMessage.message ?? '', lastMessage.mediaId ?? lastMessage.id.toString(), characterResponse.data, Boolean(lastMessage.parentMessageId ?? lastMessage.mediaId));
                    }
                });
            }
        }
    }, [lastMessage, conversation, character, generateImages, request]);
    return ((0, jsx_runtime_1.jsx)(appSocketContext.Provider, { value: {}, children: children }));
}
